var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedbubble(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920 1080",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-2 {\n        fill: #e41321;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "stickers"
  }, /*#__PURE__*/React.createElement("path", {
    id: "redbubble",
    className: "cls-2",
    d: "M751,710.43l-12.53-.69a1.08,1.08,0,0,1-1.08-1.24l4.31-29.42a1.36,1.36,0,0,1,1.42-1.11l11.62.64c8.72.48,9.84,5.38,9.25,9.41a8.4,8.4,0,0,1-2.78,5.42c3,1.41,4.33,4.29,3.74,8.31-.86,5.87-6.08,9.11-14,8.68m-18.2-1-26-1.43a1.09,1.09,0,0,1-1.08-1.24h0L710,677.34a1.37,1.37,0,0,1,1.43-1.11l12.15.67c7.6.42,11.57,4.49,10.63,10.9a10.34,10.34,0,0,1-7.3,8.64L734,707.53a1.16,1.16,0,0,1-.37,1.65,1.4,1.4,0,0,1-.86.25m8.81-59.81c-26-1.43-49.88,17.11-53.44,41.39s14.6,45.13,40.56,46.55,49.89-17.1,53.44-41.39-14.59-45.12-40.55-46.55"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedbubble);
export default __webpack_public_path__ + "static/media/redbubble.be49181d7e00ecb6b8331ff28efabe3f.svg";
export { ForwardRef as ReactComponent };